import { render, staticRenderFns } from "./TestType.vue?vue&type=template&id=45690507&"
import script from "./TestType.vue?vue&type=script&lang=js&"
export * from "./TestType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports